import React, { memo } from 'react'

import i18n from '@batical/i18n'
import { Box, Typography } from '@mui/material'

export type HeaderLineProps = {
  text?: string
}
const HeaderLine = ({ text }: HeaderLineProps) => {
  return (
    <Box sx={{ marginBottom: 2.5 }}>
      {text && (
        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1.4rem' }}>
          {i18n.t(text)}
        </Typography>
      )}
    </Box>
  )
}

export default memo(HeaderLine)
